import React, { Component } from "react";


export class Favourites extends Component {
  constructor() {
    super();

    this.state = {
      genres: [],
      currgenre: "All genres",
      movies:[],
      currText:'',
      currPage:1,
      limit:2
      
    };
  }

  componentDidMount() {
    let genreids = {
      28: "Action",
      12: "Adventure",
      16: "Animation",
      35: "Comedy",
      80: "Crime",
      99: "Documentary",
      18: "Drama",
      10751: "Family",
      14: "Fantasy",
      36: "History",
      27: "Horror",
      10402: "Music",
      9648: "Mystery",
      10749: "Romance",
      878: "Sci-Fi",
      10770: "TV",
      53: "Thriller",
      10752: "War",
      37: "Western",
    };

   
  let data = JSON.parse(localStorage.getItem("movies") || "[]");
     

   
    let tempArr = [];
    data.map((movieObj) => {
      if (!tempArr.includes(genreids[movieObj.genre_ids[0]])) {
        tempArr.push(genreids[movieObj.genre_ids[0]]);
      }
    });

    tempArr.unshift("All genres");

    this.setState({
      movies: [...data],
      genres: [...tempArr],
    });
  }
  getIndex=(movieobj)=>{
    let ticketIdx=this.state.movies.findIndex(function(movie){
         return movie.id === movieobj.id
    })
    return ticketIdx;
 }
  

  handleDelete=(movie)=>{

    let title=movie.title;
    if(window.confirm("Do you want to delete '"+title+"'?")){
     let idx=this.getIndex(movie);
     console.log(idx);
     let updatedArr=this.state.movies;
     updatedArr.splice(idx,1);
     this.setState({
      movies:[...updatedArr]
     })
    localStorage.setItem('movies',JSON.stringify(updatedArr));
    }
  }

  handleGenreChange =(genre)=>{
         this.setState({
           currgenre : genre // action
         })
  }

  sortPopularityDesc=()=>{
      let temp = this.state.movies
      temp.sort(function(objA , objB){
         return objB.popularity-objA.popularity
      })

      this.setState({
         movies : [...temp]
      })
  }

  sortPopularityAsc=()=>{
    let temp = this.state.movies
    temp.sort(function(objA , objB){
       return objA.popularity-objB.popularity
    })

    this.setState({
       movies : [...temp]
    })
}

sortRatingDesc=()=>{
  let temp = this.state.movies
  temp.sort(function(objA , objB){
     return objB.vote_average-objA.vote_average
  })

  this.setState({
     movies : [...temp]
  })
}


sortRatingAsc=()=>{
  let temp = this.state.movies
  temp.sort(function(objA , objB){
     return objA.vote_average-objB.vote_average
  })

  this.setState({
     movies : [...temp]
  })
}

handlePageChange=(page)=>{
  this.setState({
   currPage:page
  })
}

  render() {
    const genreids = {
      28: "Action",
      12: "Adventure",
      16: "Animation",
      35: "Comedy",
      80: "Crime",
      99: "Documentary",
      18: "Drama",
      10751: "Family",
      14: "Fantasy",
      36: "History",
      27: "Horror",
      10402: "Music",
      9648: "Mystery",
      10749: "Romance",
      878: "Sci-Fi",
      10770: "TV",
      53: "Thriller",
      10752: "War",
      37: "Western"
    };

    let filterArr = []

    if(this.state.currText===''){
      filterArr = this.state.movies
    }

    else{
      filterArr = this.state.movies.filter((movieObj)=>{
        let title = movieObj.original_title.toLowerCase();
        return title.includes(this.state.currText.toLowerCase().trim())
      })
    }
    
    if(this.state.currgenre!=='All genres'){
       filterArr = this.state.movies.filter((movieObj)=> genreids[movieObj.genre_ids[0]]==this.state.currgenre)
    }

   
    let pages=Math.ceil(filterArr.length/this.state.limit);
  
    let pagesArr=[];
    if(Number.isFinite(pages)){
    for(let i=1;i<=pages;i++){
      pagesArr.push(i);
    }
  }
    console.log(pages);

    console.log(pagesArr);
    let si=(this.state.currPage-1)*this.state.limit;
    let li=si+this.state.limit;

    filterArr=filterArr.slice(si,li);
    

    return (
      <div className="main">
        <div className="row">
          <div className="col-lg-3 col-sm-12 fav-genre">
            <ul class="list-group all-genre">
              {this.state.genres.map((moviegenre) =>
                this.state.currgenre == moviegenre ? (
                  <li
                    class="list-group-item"
                    style={{
                      backgroundColor: "#3f51b5",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    {moviegenre}
                  </li>
                ) : (
                  <li class="list-group-item cursor" style={{ color: "#3f51b5" }} onClick={()=>this.handleGenreChange(moviegenre)}>
                    {moviegenre}
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="col-lg-9 col-sm-12 Movie-table">
            <div className="row">
              <input
                type="text"
                className="input-group-text col "
                placeholder="Search"
              value={this.state.currText} onChange={(e)=> this.setState({currText : e.target.value})}/>
              <input type="number" className="input-group-text col " placeholder="Rows count" value={this.state.limit} onChange={(e)=>this.setState({limit:e.target.value})}/>
            </div>

            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th></th>
                    <th scope="col">Title</th>
                    <th scope="col">Genre</th>
                    
<th scope="col"><i class="fa-solid fa-sort-up cursor" onClick={this.sortPopularityDesc}></i>Popularity <i class="fa-solid fa-sort-down cursor" onClick={this.sortPopularityAsc}></i></th>
                   
                    
                    
<th scope="col"><i class="fa-solid fa-sort-up cursor" onClick={this.sortRatingDesc}></i>Rating<i class="fa-solid fa-sort-down cursor" onClick={this.sortRatingAsc}></i></th>
                    
                    <th scope="col">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {filterArr.map((movieobj) => (
                    <tr>
                      <td>
                        <img
                          className="fav-movie"
                          src={`https://image.tmdb.org/t/p/original${movieobj.backdrop_path}`}
                          alt=""
                        />
                      </td>
                      <td>{movieobj.title}</td>
                      <td>{genreids[movieobj.genre_ids[0]]}</td>
                      <td>{movieobj.popularity}</td>

                      <td>{movieobj.vote_average}</td>
                      <td>
                        <button type="button" class="btn  delete-btn" onClick={()=>this.handleDelete(movieobj)}>
                        <i class="fas fa-trash text-danger ml-1" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

         
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  {
                    pagesArr.map((page)=>(
                  <li class="page-item">
                      <a class="page-link" onClick={()=>this.handlePageChange(page)}>
                        {page}
                      </a>
                     </li>
                    ))
                  }
                
                </ul>
              </nav>
          </div>

        </div>
      </div>
    );
  }
}

export default Favourites;
